import React from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "react-bootstrap";
import cn from "classnames";
import { FaWhatsapp } from "react-icons/fa";

import { Job, Client } from "services/action";

import { Page, DetailShipmentCard, MapBox } from "ui/components";

import { formatDate, waFormat, currencyFormat } from "utilities/common";

const DetailPickup = ({ match }) => {
  const Dispatch = useDispatch();
  const History = useHistory();
  const StateLoading = useSelector(
    (state) => state?.Activity?.services["Job.Show"]
  );

  const [data, setData] = React.useState(null);
  const [client, setClient] = React.useState(null);

  const $onLoad = async (id) => {
    const req = await Dispatch(Job.$show(id));

    if (req?.message === "success") {
      setData(req?.data);
      $getClient(req?.data?.client_id);
    }
  };

  const $getClient = async (id) => {
    const res = await Dispatch(Client.$show(id));
    if (res?.message === "success") {
      setClient(res?.data);
    }
  };

  React.useEffect(() => {
    $onLoad(match?.params?.id);
  }, []);

  if (StateLoading) return null;

  const ListHorizontal = ({ title, content, className }) => {
    const c = cn(
      className ? className : "",
      "row py-1 mb-1 list-item m-0 align-items-start fsz-12 border-bottom"
    );

    return (
      <div className={c}>
        <div className="col-4 p-0 fsz-12">{title}</div>
        <div className="col-1 p-0 fsz-12">:</div>
        <div className="col-7 p-0 text-start title fsz-12">{content}</div>
      </div>
    );
  };

  const Action = () => {
    return data?.pickup_status === "new" &&
      data?.manifest?.trip_status === "started" ? (
      <div>
        <div className="row mb-2">
          <div className="col-6">
            <Button
              type="button"
              variant="success"
              className="pe-4 ps-4 rounded w-100 text-capitalize fs-7"
              onClick={() =>
                History.push({
                  pathname: "/pod",
                  state: {
                    job_id: data?.id,
                    code: data?.code,
                    type: "job-completed",
                  },
                })
              }
            >
              Selesai Pickup
            </Button>
          </div>
          <div className="col-6">
            <Button
              type="button"
              variant="danger"
              className="pe-4 ps-4 rounded w-100 text-capitalize fs-7"
              onClick={() =>
                History.push({
                  pathname: "/pod",
                  state: {
                    job_id: data?.id,
                    code: data?.code,
                    type: "job-disputed",
                  },
                })
              }
            >
              Gagal Pickup
            </Button>
          </div>
        </div>
        <Button
          type="button"
          variant="secondary"
          className="pe-4 ps-4 rounded w-100 text-capitalize fs-7"
          onClick={() =>
            window.open(
              `https://wa.me/${waFormat(
                client?.phone
              )}?text=Pickup%20dengan%20kode%20${
                data?.shipment?.code
              }%20mengalami%20kendala`,
              "_blank"
            )
          }
        >
          Laporkan Kendala
        </Button>
      </div>
    ) : null;
  };

  const renderMap = () => {
    let map = null;

    if (data?.pickup_status === "new") {
      map = <MapBox destination={data?.origin} data={data?.manifest} />;
    }

    return map;
  };

  return (
    <Page
      title={`Detail Pickup`}
      backTo={() => History.goBack()}
      action={<Action />}
    >
      {renderMap()}
      <div className="py-2 pb-5">
        <DetailShipmentCard title="Informasi Pickup">
          <ListHorizontal
            title="Kode"
            content={
              <div style={{ fontWeight: "bold" }}>{data?.shipment?.code}</div>
            }
          />
          {data?.manifest ? (
            <ListHorizontal
              title="Kode Manifest"
              content={
                <div style={{ fontWeight: "bold" }}>{data?.manifest?.code}</div>
              }
            />
          ) : null}
          {data?.booking?.ref_code ? (
            <ListHorizontal
              title="Kode Referensi"
              content={
                <div style={{ fontWeight: "bold" }}>
                  {data?.booking?.ref_code}
                </div>
              }
            />
          ) : null}

          <ListHorizontal
            title="Tanggal"
            content={formatDate(data?.schedule_at, "DD/MM/YYYY")}
          />

          {/* kalo ada recipientnnya */}
          {data?.origin ? (
            <>
              <ListHorizontal
                title="Customer"
                content={
                  <div>
                    <div style={{ fontWeight: "bold" }}>
                      {data?.origin?.name}
                    </div>
                    <div style={{ alignItems: "baseline", marginVertical: 5 }}>
                      <div>{data?.origin?.phone_number}</div>
                    </div>
                    <div
                      className="badge bg-success text-white px-3"
                      onClick={() =>
                        window.open(
                          `https://wa.me/${waFormat(
                            data?.origin?.phone_number
                          )}`,
                          "_blank"
                        )
                      }
                    >
                      <div className="d-flex align-items-center flex-row py-3">
                        {/* <Icon name="whatsapp" size={18} color={Colors.WHITE} /> */}
                        <FaWhatsapp size={15} />
                        <div>Contact</div>
                      </div>
                    </div>
                  </div>
                }
              />
              <ListHorizontal
                title="Alamat"
                content={
                  <div>
                    <div style={{ fontWeight: "bold" }}>
                      {data?.origin?.address}
                    </div>
                    <div>
                      {data?.origin?.region?.village_name},{" "}
                      {data?.origin?.region?.district_name},{" "}
                      {data?.origin?.region?.regency_name},{" "}
                      {data?.origin?.region?.province_name}
                    </div>
                  </div>
                }
              />
            </>
          ) : null}

          {data?.items ? (
            <>
              <ListHorizontal
                title="Total Koli"
                content={
                  <div style={{ fontWeight: "700" }}>
                    {currencyFormat(data?.total_quantity, false)}
                  </div>
                }
              />
              <ListHorizontal
                title="Total Berat"
                content={
                  <div style={{ fontWeight: "700" }}>
                    {currencyFormat(data?.total_weight, false)} Kg
                  </div>
                }
              />
            </>
          ) : null}
        </DetailShipmentCard>

        {data?.items ? (
          <DetailShipmentCard title="Detil Barang">
            <div className="py-2">
              <div className="table-responsive mb-0">
                <table
                  width="100%"
                  className="table table-hover table-vcenter card-table datatable border rounded"
                >
                  <thead className="bg-light">
                    <tr className="th">
                      <td style={{ whiteSpace: "nowrap", width: "15%" }}>
                        Nama Barang
                      </td>
                      <td style={{ whiteSpace: "nowrap", width: "15%" }}>
                        Koli
                      </td>
                      <td style={{ whiteSpace: "nowrap", width: "15%" }}>
                        Berat (Kg)
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    {data?.items?.map((d, i) => (
                      <tr key={i}>
                        <td style={{ whiteSpace: "nowrap", width: "15%" }}>
                          {d?.item_name}
                        </td>
                        <td style={{ whiteSpace: "nowrap", width: "15%" }}>
                          {d?.quantity}
                        </td>
                        <td style={{ whiteSpace: "nowrap", width: "15%" }}>
                          {d?.weight}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </DetailShipmentCard>
        ) : null}
      </div>
    </Page>
  );
};

export default DetailPickup;
